// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a33da598","73":"16c79e25","99":"765ee760","102":"46035225","188":"ed21cac1","234":"0b124303","315":"cde7583c","323":"1d014901","382":"18661037","427":"9249e0cc","574":"63273f39","610":"9f61ecbc","727":"6e42772b","744":"373c8d0c","845":"b66fc2a5","872":"02323bfa"}[chunkId] + ".chunk.js";
};